var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-scene area"
  }, [_vm._m(0), _c("section", {
    staticClass: "product-scene__card"
  }, [_c("a-row", _vm._l(_vm.sceneList, function (item, index) {
    return _c("a-col", {
      key: index,
      attrs: {
        span: 6
      }
    }, [_c("scene-card", {
      attrs: {
        card: item
      }
    })], 1);
  }), 1)], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "product-scene__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("SCENE")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("应用场景")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };